import {Time} from 'yougile-util'
import {TableRow} from '../../common/base/table/types'
import {CrmActivitiesFilters, CrmActivitiesStats, RowData} from '../common'
import {isThatDayByDate} from '../custom-format-date'

export const getStats = (
  tableRows: TableRow<RowData>[],
  filters: CrmActivitiesFilters
): CrmActivitiesStats => {
  const stats = {
    dayCurrent: 0,
    dayPrev: 0,
    dayNext: 0,
    failed: 0,
    completed: 0
  }

  for (const row of tableRows) {
    if (!row.data.activity.completed) {
      if (isThatDayByDate(row.data.activity.deadline, filters.selectedDay)) {
        stats.dayCurrent++
      } else if (
        isThatDayByDate(
          row.data.activity.deadline,
          filters.selectedDay - Time.day
        )
      ) {
        stats.dayPrev++
      } else if (
        isThatDayByDate(
          row.data.activity.deadline,
          filters.selectedDay + Time.day
        )
      ) {
        stats.dayNext++
      }
    }

    if (
      row.data.activity.deadline < Time.now() &&
      !row.data.activity.completed
    ) {
      stats.failed++
    }
    if (row.data.activity.completed) {
      stats.completed++
    }
  }

  return stats
}
